import {
  PaymentForm,
  paymentFormOutputTransformer,
} from '../interfaces/Checkout/PaymentForm';
import api, { apiPrefix } from './Api';

export const checkout = async (
  paymentForm: PaymentForm,
): Promise<string | undefined> => {
  const response = await api.post(
    apiPrefix +
      (paymentForm.paymentMethod === 'bank_transfer'
        ? '/checkout'
        : '/checkout-credit'),
    paymentFormOutputTransformer(paymentForm),
  );

  return response.data?.url;
};
